import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';

export const selectSelf = (state: RootState) => state.user;

export const selectArtists = createSelector(
  selectSelf,
  (user) => user.artists ?? null
);

export const selectRemainingLoopUploads = createSelector(
  selectSelf,
  (user) => user.uploadAudioLimit
);

export const selectSongDownloadLimit = createSelector(
  selectSelf,
  (user) => user.songDownloadLimit
);

export const selectStemsDownloadLimit = createSelector(
  selectSelf,
  (user) => user.stemsDownloadLimit
);

export const selectSamplePackDownloadLimit = createSelector(
  selectSelf,
  (user) => user.samplePackDownloadLimit
);

export const selectAIGenerationLimit = createSelector(
  selectSelf,
  (user) => user.aiGenerationLimit
);

export const selectStudioExportLimit = createSelector(
  selectSelf,
  (user) => user.studioExportLimit
);

export const selectSubmitReleaseLimit = createSelector(
  selectSelf,
  (user) => user.submitReleaseLimit
);

export const selectSubscriptionType = createSelector(
  selectSelf,
  (user) => user.subscriptionType
);

export const selectHasDistribution = createSelector(
  selectSelf,
  (user) => user.hasDistribution
);

export const selectIsSubmitReleaseLimitReached = createSelector(
  selectSelf,
  (user) => {
    const { submitReleaseLimit, hasDistribution } = user;
    if (!hasDistribution) return false;

    if (
      submitReleaseLimit?.remaining === undefined ||
      submitReleaseLimit?.remaining === null
    ) {
      return false;
    }
    if (submitReleaseLimit.remaining > 0) {
      return false;
    }

    return true;
  }
);

export const selectEmailConfirmed = createSelector(
  selectSelf,
  (user) => user.emailConfirmed
);
